import Explore from "@/pages/customer/Explore";

export default function CategoryPage({ category, title, subtitle }) {
  return <Explore key={category} lockedCategory={category} heroTitle={title} heroSubtitle={subtitle} />;
}
